
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium-themes/onepirate/terms",
      function () {
        return require("private-next-pages/premium-themes/onepirate/terms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium-themes/onepirate/terms"])
      });
    }
  